"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex justify-end" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_10 = {
    key: 1,
    class: "text-red font-bold block"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
    key: 4,
    class: "text-red font-bold"
};
const _hoisted_13 = { class: "grow truncate" };
const _hoisted_14 = ["href"];
const _hoisted_15 = { class: "grow-0" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_18 = { class: "py-4 border-t-1 border-gray" };
const _hoisted_19 = { class: "mb-2" };
const _hoisted_20 = { class: "uppercase text-sm font-bold" };
const _hoisted_21 = { class: "text-xs" };
const _hoisted_22 = { class: "py-4 border-t-1 border-b-1 border-gray" };
const _hoisted_23 = { class: "mb-2" };
const _hoisted_24 = { class: "uppercase text-sm font-bold" };
const _hoisted_25 = { class: "text-xs" };
const _hoisted_26 = { class: "flex items-center my-5 gap-4" };
const _hoisted_27 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_28 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const News_1 = require("../../stores/news/News");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const Form_1 = require("../../components/Form");
const vue_router_1 = require("vue-router");
const NewsRequest_1 = require("../../stores/news/NewsRequest");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const newsStore_1 = require("../../stores/news/newsStore");
const newsFileStore_1 = require("../../stores/newsFiles/newsFileStore");
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const SearchInputOption_1 = __importDefault(require("../../components/Form/SearchInput/SearchInputOption"));
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const SkuTagSearchInput_vue_1 = __importDefault(require("../../components/ProductSearch/SkuTagSearchInput.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminNews',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g;
        const newsStore = (0, newsStore_1.useNewsStore)();
        const newsFileStore = (0, newsFileStore_1.useNewsFileStore)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB
        const newsLoading = (0, vue_3.computed)(() => newsStore.loading);
        const news = (0, vue_3.computed)(() => newsStore.news);
        const totalNews = (0, vue_3.computed)(() => newsStore.totalNews);
        const searchedMultiSelectorItems = (0, vue_3.ref)([]);
        const selectedMultiSelectorItems = (0, vue_3.ref)([]);
        const customerGroupOptions = (0, vue_3.ref)((_a = ShopConfig_1.ShopConfig.getCustomerGroups().map(group => new SearchInputOption_1.default(group, group))) !== null && _a !== void 0 ? _a : []);
        const departmentOptions = (0, vue_3.ref)((_b = ShopConfig_1.ShopConfig.getDepartments().map(dept => new SearchInputOption_1.default(dept, dept))) !== null && _b !== void 0 ? _b : []);
        const selectedNewsFiles = (0, vue_3.computed)(() => newsFileStore.newsFiles);
        const errorMessage = (0, vue_3.ref)("");
        const modalIsOpen = (0, vue_3.ref)(false);
        const selectedNews = (0, vue_3.ref)(null);
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_c = (0, i18n_1.trans)("id", "ID", "news")) !== null && _c !== void 0 ? _c : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "fileUrl",
                label: (_d = (0, i18n_1.trans)("fileUrl", "Image", "news")) !== null && _d !== void 0 ? _d : "Image",
                value: "fileUrl",
                sortable: true,
                filterable: true,
            },
            {
                key: "createdDatetime",
                label: (_e = (0, i18n_1.trans)("createdDatetime", "Date created", "news")) !== null && _e !== void 0 ? _e : "Date created",
                value: "createdDatetime",
                sortable: true,
                filterable: true,
            },
            {
                key: "title",
                label: (_f = (0, i18n_1.trans)("title", "Title", "news")) !== null && _f !== void 0 ? _f : "Title",
                value: "title",
                filterable: true,
                sortable: true,
            },
            {
                key: "locale",
                label: (_g = (0, i18n_1.trans)("locale", "Locale", "news")) !== null && _g !== void 0 ? _g : "Locale",
                value: "locale",
                filterable: true,
                sortable: true,
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const sortBy = (0, vue_3.ref)("createdDatetime");
        const sortDesc = (0, vue_3.ref)(true);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const uploadedFile = (0, vue_3.ref)(null);
        const fileErrorMessage = (0, vue_3.ref)("");
        const base64FileErrorMessage = (0, vue_3.ref)("");
        const newsRequest = (0, vue_3.ref)(new NewsRequest_1.NewsRequest());
        const dynamicVariables = {};
        const newsQuery = (0, vue_3.computed)(() => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        (0, vue_3.onBeforeMount)(() => {
            newsStore.reset();
            News_1.NEWS_CATEGORIES.forEach(function (value) {
                dynamicVariables[`${value}`] = (0, vue_3.ref)(false);
            });
        });
        const addNews = () => {
            newsRequest.value = new NewsRequest_1.NewsRequest();
            selectedNews.value = null;
            selectedMultiSelectorItems.value = [];
            searchedMultiSelectorItems.value = [];
            newsFileStore.reset();
            modalIsOpen.value = true;
        };
        const editNews = async (news) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            selectedNews.value = { ...news };
            (_a = selectedNews.value) === null || _a === void 0 ? void 0 : _a.category.forEach(function (value) {
                dynamicVariables[`${value}`].value = true;
            });
            newsRequest.value = new NewsRequest_1.NewsRequest((_b = selectedNews.value) === null || _b === void 0 ? void 0 : _b.locale, (_c = selectedNews.value) === null || _c === void 0 ? void 0 : _c.title, (_d = selectedNews.value) === null || _d === void 0 ? void 0 : _d.description, (_e = selectedNews.value) === null || _e === void 0 ? void 0 : _e.body, [...((_g = (_f = selectedNews.value) === null || _f === void 0 ? void 0 : _f.category) !== null && _g !== void 0 ? _g : [])], (_h = selectedNews.value) === null || _h === void 0 ? void 0 : _h.createdUser, (_j = selectedNews.value) === null || _j === void 0 ? void 0 : _j.originalFileName, null, [...((_l = (_k = selectedNews.value) === null || _k === void 0 ? void 0 : _k.customerGroups) !== null && _l !== void 0 ? _l : [])], [...((_o = (_m = selectedNews.value) === null || _m === void 0 ? void 0 : _m.departments) !== null && _o !== void 0 ? _o : [])]);
            try {
                const response = await newsStore.getArticle(router, news.id);
                newsRequest.value.body = response.body;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            try {
                await newsFileStore.getNewsFiles(router, { pagination: false, news: news.id });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            modalIsOpen.value = true;
        };
        const deleteNews = async (news) => {
            var _a;
            if (!confirm((_a = (0, i18n_1.trans)("delete_news_confirm", "Are you sure?", "news")) !== null && _a !== void 0 ? _a : "Are you sure?")) {
                return;
            }
            errorMessage.value = "";
            try {
                await newsStore.deleteNews(router, news);
                selectedNews.value = null;
                newsStore.reset();
                await newsStore.getNews(router, newsQuery.value);
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const createNews = async () => {
            var _a;
            errorMessage.value = "";
            base64FileErrorMessage.value = "";
            const base64Valid = await validateNewsBase64File();
            if (!base64Valid)
                return;
            if (securityStore.authenticatedUser === null) {
                return;
            }
            Object.keys(dynamicVariables).forEach((key) => {
                if (dynamicVariables[key].value) {
                    newsRequest.value.category.push(key);
                }
            });
            if (Object.values(dynamicVariables).every(refValue => !refValue.value)) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("category_invalid", "You need to choose a news category!", "news")) !== null && _a !== void 0 ? _a : "You need to choose a news category!");
                return;
            }
            newsRequest.value.createdUser = securityStore.authenticatedUser.iri;
            try {
                await newsStore.createNews(router, newsRequest.value);
                modalIsOpen.value = false;
                newsStore.reset();
                try {
                    await newsStore.getNews(router, newsQuery.value);
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const updateNews = async () => {
            var _a;
            errorMessage.value = "";
            base64FileErrorMessage.value = "";
            const base64Valid = await validateNewsBase64File();
            if (!base64Valid)
                return;
            if (securityStore.authenticatedUser === null) {
                return;
            }
            if (Object.values(dynamicVariables).every(refValue => !refValue.value)) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("category_invalid", "You need to choose a news category!", "news")) !== null && _a !== void 0 ? _a : "You need to choose a news category!");
                return;
            }
            News_1.NEWS_CATEGORIES.forEach(function (value) {
                let checked = newsRequest.value.category.indexOf(value);
                if (dynamicVariables[value].value && checked < 0) {
                    newsRequest.value.category.push(value);
                }
                else if (!dynamicVariables[value].value && checked >= 0) {
                    newsRequest.value.category.splice(checked, 1);
                }
            });
            newsRequest.value.createdUser = securityStore.authenticatedUser.iri;
            try {
                await newsStore.updateNews(router, newsRequest.value, selectedNews.value.id);
                modalIsOpen.value = false;
                newsStore.reset();
                try {
                    await newsStore.getNews(router, newsQuery.value);
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const deleteNewsFile = async (newsFile) => {
            if (!confirm((0, i18n_1.trans)("delete_news_file_confirm", "Are you sure?", "news"))) {
                return;
            }
            errorMessage.value = "";
            try {
                await newsFileStore.deleteNewsFile(router, newsFile);
                if (selectedNews.value === null) {
                    return;
                }
                newsFileStore.reset();
                try {
                    await newsFileStore.getNewsFiles(router, { pagination: false, news: selectedNews.value.id });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const saveNewsFile = async () => {
            var _a, _b, _c;
            errorMessage.value = "";
            fileErrorMessage.value = "";
            if (selectedNews.value === null) {
                return;
            }
            const formData = new FormData();
            if (uploadedFile.value === null) {
                fileErrorMessage.value = (_a = (0, i18n_1.trans)("file_not_selected", "No file selected", "news")) !== null && _a !== void 0 ? _a : "No file selected";
                return;
            }
            const allowedMimeTypes = ["image/png", "image/jpeg", "application/pdf"];
            if (!allowedMimeTypes.includes(uploadedFile.value.type)) {
                fileErrorMessage.value = (_b = (0, i18n_1.trans)("invalid_file_type_text_2", "Invalid file type (only PNG/JPG/PDF)", "news")) !== null && _b !== void 0 ? _b : "Invalid file type (only PNG/JPG/PDF)";
                return;
            }
            if (uploadedFile.value.size > MAX_FILE_SIZE) {
                fileErrorMessage.value = (_c = (0, i18n_1.trans)("file_too_large", "File too large (max 3MB)", "news")) !== null && _c !== void 0 ? _c : "File too large (max 3MB)";
                return;
            }
            formData.append("file", uploadedFile.value);
            formData.append("newsId", String(selectedNews.value.id));
            try {
                await newsFileStore.saveNewsFile(router, formData);
                if (selectedNews.value === null) {
                    return;
                }
                uploadedFile.value = null;
                fileErrorMessage.value = "";
                newsFileStore.reset();
                try {
                    await newsFileStore.getNewsFiles(router, { pagination: false, news: selectedNews.value.id });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        const onCustomerGroupTagsChanged = (tags) => {
            newsRequest.value.customerGroups = tags.map(tag => tag.value);
        };
        const onDepartmentTagsChanged = (tags) => {
            newsRequest.value.departments = tags.map(tag => tag.value);
        };
        const validateNewsBase64File = async () => {
            var _a, _b, _c, _d;
            const base64 = newsRequest.value.base64EncodedFile;
            if (!base64 || !base64.length) {
                base64FileErrorMessage.value = "";
                return true;
            }
            const mimeMatch = base64.match(/^data:(image\/(png|jpeg));base64,/);
            if (!mimeMatch) {
                base64FileErrorMessage.value = (_a = (0, i18n_1.trans)("invalid_file_type_text_1", "Invalid file type (only PNG/JPG)", "news")) !== null && _a !== void 0 ? _a : "Invalid file type (only PNG/JPG)";
                return false;
            }
            const base64DataPart = (_b = base64.split(",")[1]) !== null && _b !== void 0 ? _b : "";
            const padding = (base64DataPart.match(/=+$/) || [""])[0].length;
            const sizeBytes = Math.ceil((base64DataPart.length * 3) / 4) - padding;
            if (sizeBytes > MAX_FILE_SIZE) {
                base64FileErrorMessage.value = (_c = (0, i18n_1.trans)("file_too_large", "File too large (max 3MB)", "news")) !== null && _c !== void 0 ? _c : "File too large (max 3MB)";
                return false;
            }
            const dimsValid = await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => {
                    resolve(img.width >= 500 && img.height >= 200);
                };
                img.onerror = () => resolve(false);
                img.src = base64;
            });
            if (!dimsValid) {
                base64FileErrorMessage.value = (_d = (0, i18n_1.trans)("invalid_dimensions", "Invalid dimensions. Min 500x200", "news")) !== null && _d !== void 0 ? _d : "Invalid dimensions. Min 500x200";
                return false;
            }
            return true;
        };
        (0, vue_3.watch)(modalIsOpen, (value) => {
            if (!value) {
                errorMessage.value = "";
                base64FileErrorMessage.value = "";
                fileErrorMessage.value = "";
                Object.keys(dynamicVariables).forEach((key) => {
                    dynamicVariables[key].value = false;
                });
            }
        });
        (0, vue_3.watch)(newsQuery, async () => {
            try {
                await newsStore.getNews(router, newsQuery.value);
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (addNews()))
                    }, [
                        _hoisted_3,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_news", "Add News", "news")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((listFields).value = $event)),
                    items: (0, vue_2.unref)(news),
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: (0, vue_2.unref)(newsLoading),
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[3] || (_cache[3] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: (0, vue_2.unref)(totalNews)
                }, {
                    "cell-fileUrl": (0, vue_2.withCtx)(({ item: news }) => [
                        (0, vue_2.createElementVNode)("img", {
                            src: news.fileUrl,
                            class: "w-[100px] bg-white"
                        }, null, 8, _hoisted_4)
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: news }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link",
                                onClick: ($event) => (editNews(news))
                            }, [
                                _hoisted_7,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("edit", "Edit", "news")), 1)
                            ], 8, _hoisted_6),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link",
                                onClick: ($event) => (deleteNews(news))
                            }, [
                                _hoisted_9,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "news")), 1)
                            ], 8, _hoisted_8)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    title: selectedNews.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('edit_news_modal_title', 'Edit News: {group}', 'news', { group: selectedNews.value.title })
                        : (0, vue_2.unref)(i18n_1.trans)('add_news_modal', 'Add News', 'news'),
                    onClose: _cache[14] || (_cache[14] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('save_error', 'Save error', 'news'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.LanguageSelector), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('news_locale_placeholder', 'News Locale', 'news'),
                            label: (0, vue_2.unref)(i18n_1.trans)('news_locale_label', 'News Locale', 'news'),
                            modelValue: newsRequest.value.locale,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((newsRequest.value.locale) = $event)),
                            class: "my-5"
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('news_title_placeholder', 'News Title', 'news'),
                            label: (0, vue_2.unref)(i18n_1.trans)('news_title_label', 'News Title', 'news'),
                            required: "",
                            modelValue: newsRequest.value.title,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((newsRequest.value.title) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('news_description_placeholder', 'News Description', 'news'),
                            label: (0, vue_2.unref)(i18n_1.trans)('news_description_label', 'News Description', 'news'),
                            required: "",
                            modelValue: newsRequest.value.description,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((newsRequest.value.description) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.FileInputBase64), {
                            "base64-encode-file": newsRequest.value.base64EncodedFile,
                            "onUpdate:base64EncodeFile": _cache[9] || (_cache[9] = ($event) => ((newsRequest.value.base64EncodedFile) = $event)),
                            "original-filename": newsRequest.value.originalFilename,
                            "onUpdate:originalFilename": _cache[10] || (_cache[10] = ($event) => ((newsRequest.value.originalFilename) = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('news_image', 'News Image (min 500x200 png/jpg/jpeg)', 'news'),
                            accept: ".png, .jpg, .jpeg",
                            placeholder: "Image",
                            class: "my-5"
                        }, null, 8, ["base64-encode-file", "original-filename", "label"]),
                        (base64FileErrorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_10, (0, vue_2.toDisplayString)(base64FileErrorMessage.value), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (selectedNews.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                key: 2,
                                href: selectedNews.value.fileUrl,
                                class: "underline",
                                target: "_blank"
                            }, (0, vue_2.toDisplayString)(selectedNews.value.filename), 9, _hoisted_11))
                            : (0, vue_2.createCommentVNode)("", true),
                        (selectedNews.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.FileInput), {
                                key: 3,
                                modelValue: uploadedFile.value,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((uploadedFile).value = $event)),
                                label: (0, vue_2.unref)(i18n_1.trans)('news_files', 'News Files (png/jpg/jpeg/pdf max 3MB)', 'news'),
                                accept: "image/png,image/jpeg,application/pdf"
                            }, {
                                button: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-primary",
                                        onClick: saveNewsFile
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("upload", "Upload", "news")), 1)
                                ]),
                                _: 1
                            }, 8, ["modelValue", "label"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (fileErrorMessage.value.length && selectedNews.value !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_12, (0, vue_2.toDisplayString)(fileErrorMessage.value), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(selectedNewsFiles), (newsFile) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: newsFile.id,
                                class: "flex flex-wrap"
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                    (0, vue_2.createElementVNode)("a", {
                                        target: "_blank",
                                        href: newsFile.contentUrl
                                    }, (0, vue_2.toDisplayString)(newsFile.originalFileName), 9, _hoisted_14)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-rounded btn-danger btn-link",
                                        onClick: ($event) => (deleteNewsFile(newsFile))
                                    }, [
                                        _hoisted_17,
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "news")), 1)
                                    ], 8, _hoisted_16)
                                ])
                            ]));
                        }), 128)),
                        (0, vue_2.createElementVNode)("div", _hoisted_18, [
                            (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_groups_label", "Customer groups", "news")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_21, " (" + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_groups_optional_note", "Setting it is optional. If you don’t set it, it will be visible to everyone.", "news")) + ") ", 1)
                            ]),
                            (0, vue_2.createVNode)(SkuTagSearchInput_vue_1.default, {
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_groups_filter_placeholder', 'Search and set customer groups to control banner visibility', 'news'),
                                options: customerGroupOptions.value,
                                "lg-max-width": "500px",
                                "initial-tags": newsRequest.value.customerGroups,
                                onTagsChanged: onCustomerGroupTagsChanged
                            }, null, 8, ["placeholder", "options", "initial-tags"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                            (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                (0, vue_2.createElementVNode)("div", _hoisted_24, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("departments_label", "Departments", "news")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_25, " (" + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("departments_optional_note", "Setting it is optional. If you don’t set it, it will be visible to everyone.", "news")) + ") ", 1)
                            ]),
                            (0, vue_2.createVNode)(SkuTagSearchInput_vue_1.default, {
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('departments_filter_placeholder', 'Search and set departments to control banner visibility', 'news'),
                                options: departmentOptions.value,
                                "lg-max-width": "500px",
                                "initial-tags": newsRequest.value.departments,
                                onTagsChanged: onDepartmentTagsChanged
                            }, null, 8, ["placeholder", "options", "initial-tags"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_26, [
                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(dynamicVariables, (item, index) => {
                                return (0, vue_2.createElementVNode)("div", { key: index }, [
                                    (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                        label: (0, vue_2.unref)(i18n_1.trans)('is_' + index + '_news', index + ' news: ', 'news'),
                                        modelValue: dynamicVariables[index].value,
                                        "onUpdate:modelValue": ($event) => ((dynamicVariables[index].value) = $event),
                                        class: "p-2 bg-gray justify-between w-full"
                                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                                ]);
                            }), 64))
                        ]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.TextEditor), {
                            label: (0, vue_2.unref)(i18n_1.trans)('news_body', 'News Body', 'news'),
                            modelValue: newsRequest.value.body,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((newsRequest.value.body) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["label", "modelValue"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_27, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary",
                                onClick: _cache[13] || (_cache[13] = ($event) => (selectedNews.value === null ? createNews() : updateNews()))
                            }, [
                                _hoisted_28,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "news")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
